import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "toast-container" };
import { useNotificationStore } from '@/IsekaiRPG/modules/ui/uiStores';
import { storeToRefs } from 'pinia';
import ToastItem from './ToastItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastContainer',
    setup(__props) {
        const store = useNotificationStore();
        const { notifications } = storeToRefs(store);
        const { remove } = store;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_TransitionGroup, { name: "toast" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification) => {
                            return (_openBlock(), _createBlock(ToastItem, {
                                key: notification.id,
                                notification: notification,
                                onClose: ($event) => (_unref(remove)(notification.id))
                            }, null, 8 /* PROPS */, ["notification", "onClose"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
